import { useCallback, useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';

import styles from '../../css/style.module.css';

import { IoSearchSharp } from 'react-icons/io5';
import { VscSettings } from 'react-icons/vsc';

import { MdOutlineRemoveRedEye } from 'react-icons/md';
import HOC from '../../components/HOC/HOC';
import FilterModal from '../../components/Modals/FilterModal';
import { DeleteSuccessfullyModal, SuccessfullyModal } from '../../components/Modals/Modals';
import Pagination from '../../components/Pagination/Pagination';
import { deleteApi, getApi, postApi } from '../../Repository/Api';
import endPoints from '../../Repository/apiConfig';
import { formatDate } from '../../utils/utils';
import { OrderCancelModal } from '../../components/Modals/Modals';

import img2 from '../../assest/loading1.gif';

const columns = [
  'S.no',
  'Date',
  'Party Name',
  'Site Name',
  'Sub Category Name',
  'Shift Timing',
  'Current/ Required',
  'Status',
  'Assigned Partner',
  'Accepted Assigned Partner',
  'Started Duty',
  'Completed Duty',
  'Action',
];

const Orders = () => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [orderdata, setOrderData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selecteddata, setSelectedData] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchValue, setSearchValue] = useState('');
  const [showOrderCancelModal, setShowOrderCancelModal] = useState(false);
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const page = parseInt(searchParams.get('page')) || 1;
  const search = searchParams.get('search') || '';
  const selectedFilter = searchParams.get('filter') || '';

  const [pagination, setPagination] = useState({
    limit: 10,
    totalPages: 1,
    page,
    hasPrevPage: false,
    hasNextPage: false,
  });

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  const fetchData = useCallback(async () => {
    if (search) {
      setPagination(prevPagination => ({
        ...prevPagination,
        page: 1,
      }));
    }
    await getApi(endPoints.getallorder(pagination.page, pagination.limit, search, selectedFilter), {
      setResponse: setOrderData,
      setLoading,
      errorMsg: 'Failed to fetch order!',
      onError: () => setOrderData([]),
    });
  }, [pagination.page, pagination.limit, search, selectedFilter]);

  useEffect(() => {
    setPagination(prevPagination => ({
      ...prevPagination,
      totalPages: orderdata?.data?.totalPages,
      hasPrevPage: orderdata?.data?.hasPrevPage,
      hasNextPage: orderdata?.data?.hasNextPage,
    }));
  }, [orderdata]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // Debounce search
  useEffect(() => {
    const timer = setTimeout(() => {
      if (searchValue !== search) {
        setSearchParams({ page: 1, search: searchValue, filter: selectedFilter });
      }
    }, 500);
    return () => clearTimeout(timer);
  }, [searchValue]);

  const handleDelete = async () => {
    if (!selecteddata) return;
    await deleteApi(endPoints.deletecategory(selecteddata), {
      setLoading,
      errorMsg: 'Failed to delete order!',
    });
    fetchData();
    setShowDeleteModal(false);
    setShowSuccessModal(true);
    setTimeout(() => setShowSuccessModal(false), 2000);
  };

  const filterOptions = [
    { label: 'Completed', value: 'Completed' },
    { label: 'Pending', value: 'Pending' },
  ];

  const handleSearchChange = e => {
    setSearchValue(e.target.value);
  };

  const handleApply = appliedFilter => {
    setSearchParams({ page: 1, search: searchValue, filter: appliedFilter });
    setShowDropdown(false);
  };

  const handlePageChange = newPage => {
    setSearchParams({ page: newPage, search: searchValue, filter: selectedFilter });
    setPagination({ ...pagination, page: newPage });
  };

  const handleCancelOrder = async () => {
    await postApi(endPoints.cancelorder, {
      bookingId: selectedOrderId,
      cancelReason: 'Admin cancelled',
      cancelledBy: 'ADMIN',
    });
    setShowOrderCancelModal(false);
    fetchData();
    setShowSuccessModal(true);
    setTimeout(() => setShowSuccessModal(false), 2000);
  };

  return (
    <>
      <DeleteSuccessfullyModal
        show={showDeleteModal}
        handleClose={() => setShowDeleteModal(false)}
        handleshow={handleDelete}
        text="delete Order"
      />
      <SuccessfullyModal
        show={showSuccessModal}
        handleClose={() => setShowSuccessModal(false)}
        text="Successfully Deleted"
      />
      <OrderCancelModal
        show={showOrderCancelModal}
        handleClose={() => setShowOrderCancelModal(false)}
        handleConfirm={handleCancelOrder}
        text="Cancel Order"
      />
      <div className={styles.jobmanagementCotainer}>
        <div className={styles.jobtoppart}>
          <div className={styles.pagetitle}>
            <h6>Orders</h6>
            <div className={styles.searchbarnav}>
              <IoSearchSharp color="#8A8A8A" size={20} />
              <input
                type="search"
                placeholder="Search"
                value={searchValue}
                onChange={handleSearchChange}
              />
            </div>
          </div>
          <div className={styles.filterbutton} onClick={toggleDropdown}>
            <VscSettings color="#737373" size={20} />
            <p>Filters</p>
          </div>
          {showDropdown && (
            <FilterModal
              handleApply={handleApply}
              filterOptions={filterOptions}
              selectedFilter={selectedFilter}
            />
          )}
        </div>
        <div className={styles.jobchildcontainer}>
          <div className={styles.tablecontainer}>
            <table className={styles.table1}>
              <thead>
                <tr>
                  {columns.map((label, index) => (
                    <th key={index} className={styles.tableHeader}>
                      {label}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="13" style={{ textAlign: 'center', padding: '1rem' }}>
                      <img src={img2} alt="" width={100} height={100} />
                    </td>
                  </tr>
                ) : orderdata?.data?.docs?.length === 0 ? (
                  <tr>
                    <td colSpan="13" style={{ textAlign: 'center', padding: '1rem' }}>
                      No data available.
                    </td>
                  </tr>
                ) : (
                  orderdata?.data?.docs?.map((itme, rowIndex) => (
                    <tr key={rowIndex} className={styles.tableRow}>
                      <td className={styles.tableCell}>
                        {(pagination.page - 1) * pagination.limit + rowIndex + 1}
                      </td>
                      <td className={styles.tableCell}>{formatDate(itme?.jobs?.[0]?.date)} </td>
                      <td> {itme?.partyName}</td>
                      <td> {itme?.siteName || itme?.invoiceName || '-'}</td>
                      <td> {itme?.subCategories?.map(item => item + '\n')}</td>
                      <td> {itme?.shiftTiming}</td>
                      <td
                        className={styles.tableCell}
                        style={{
                          color:
                            itme?.jobStatus === 'Pending'
                              ? ' #FFA800'
                              : itme?.jobStatus === 'Completed'
                                ? '#00AD1D'
                                : 'black',
                          fontWeight: '600',
                        }}
                      >
                        {`${itme?.staffAccepted?.length || 0}`} /{' '}
                        {itme?.jobs?.[0]?.subCategories?.[0]?.pax}
                      </td>
                      <td
                        className={styles.tableCell}
                        style={{
                          color:
                            itme?.customStatus === 'Cancelled' ||
                            itme?.customStatus === 'Cancelled Order'
                              ? 'red'
                              : itme?.customStatus === 'Pending'
                                ? '#FFA800'
                                : itme?.customStatus === 'All Accepted'
                                  ? '#00AD1D'
                                  : 'black',
                          fontWeight: '600',
                        }}
                      >
                        {itme?.customStatus}
                      </td>
                      <td
                        className={styles.tableCell}
                        style={{ maxHeight: '130px', overflowY: 'auto', display: 'block' }}
                      >
                        <ul>
                          {itme?.staff?.map((itme, rowIndex) => (
                            <li key={rowIndex}>
                              {itme.firstName} {itme.lastName}
                            </li>
                          ))}
                        </ul>
                      </td>
                      <td
                        className={styles.tableCell}
                        style={{ maxHeight: '130px', overflowY: 'auto' }}
                      >
                        <ul>
                          {itme?.staffAccepted?.map((itme, rowIndex) => (
                            <li key={rowIndex}>
                              {itme.firstName} {itme.lastName}
                            </li>
                          ))}
                        </ul>
                      </td>
                      <td
                        className={styles.tableCell}
                        style={{ maxHeight: '130px', overflowY: 'auto' }}
                      >
                        <ul>
                          {itme?.acceptedStaffBooking?.map((itme, rowIndex) => (
                            <li key={rowIndex}>
                              {itme.staff?.firstName} {itme.staff?.lastName}
                            </li>
                          ))}
                        </ul>
                      </td>
                      <td
                        className={styles.tableCell}
                        style={{ maxHeight: '130px', overflowY: 'auto' }}
                      >
                        <ul>
                          {itme?.acceptedStaffBooking
                            ?.filter(item => Boolean(item.endTime))
                            ?.map((itme, rowIndex) => (
                              <li key={rowIndex}>
                                {itme.staff?.firstName} {itme.staff?.lastName}
                              </li>
                            ))}
                        </ul>
                      </td>
                      <td>
                        <div className={styles.tableaction}>
                          <div className={styles.tablecreatebutton}>
                            <Link to={`/orders/assignjob/${itme._id}`}>
                              <button>Assign Job</button>
                            </Link>
                          </div>
                          <Link to={`/orders/details/${itme?._id}?page=${pagination?.page || 1}`}>
                            <MdOutlineRemoveRedEye size={20} />
                          </Link>

                          {(itme?.customStatus === 'Pending' ||
                            itme?.customStatus === 'All Accepted' ||
                            itme?.customStatus === 'In Progress') && (
                            <button
                              onClick={() => {
                                setShowOrderCancelModal(true);
                                setSelectedOrderId(itme?._id);
                              }}
                              style={{
                                backgroundColor: 'red',
                                color: 'white',
                                padding: '5px 10px',
                                borderRadius: '5px',
                                cursor: 'pointer',
                                border: 'none',
                              }}
                            >
                              Cancel Order
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
          <Pagination
            limit={pagination.limit}
            totalPages={pagination.totalPages}
            page={pagination.page}
            hasPrevPage={pagination.hasPrevPage}
            hasNextPage={pagination.hasNextPage}
            onPageChange={handlePageChange}
          />
        </div>
      </div>
    </>
  );
};

export default HOC(Orders);
